import './StackedBars.scss'

import React, { Component } from 'react'

export default class StackedBars extends Component {
  constructor(props) {
    super(props)
  }

  getVal = (val) => {
    return val ? val.toFixed(1) : 0
  }

  renderBarRow = (entry, idx) => {
    return (
      <div className="StackedBars__bar" style={{width: `${this.getVal(entry.value)}%`}} key={idx}>
        <div></div>
        <div className="StackedBars__bar--val">{entry.label ? entry.label : `${this.getVal(entry.value)}%`}</div>
      </div>
    )
  }

  render() {
    const { data } = this.props

    return (
      <div className="StackedBars">
        <div className="StackedBars__left-sec">
          { data.map((entry, idx) => <div className="StackedBars__title" key={idx}>{entry.title}</div> ) }
        </div>
        <div className="StackedBars__right-sec">
          { data.map(this.renderBarRow) }
        </div>
      </div>
    )
  }
}
